// === INIT UPSALE KNOPPEN ===
function initCartUpsellButtons() {
  const buttons = document.querySelectorAll('.cart-upsell-add:not(.initialized)');

  buttons.forEach((button) => {
    button.classList.add('initialized');

    button.addEventListener('click', () => {
      const variantId = button.dataset.variantId;

      button.disabled = true;
      button.textContent = 'Toevoegen...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Fout bij toevoegen');
          return res.json();
        })
        .then(() => fetch('/?section_id=cart-drawer_custom'))
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('#CartDrawer');
          if (newDrawer) {
            document.querySelector('#CartDrawer').innerHTML = newDrawer.innerHTML;
          }
        })
        .then(() => {
          initCartUpsellButtons(); // opnieuw binden
        })
        .catch((err) => {
          console.error(err);
          alert('Er ging iets mis bij het toevoegen.');
        })
        .finally(() => {
          button.disabled = false;
          button.textContent = 'Toegevoegd ✓';
          setTimeout(() => {
            button.textContent = 'Voeg toe';
          }, 1500);
        });
    });
  });
}

// === INIT BIJ LAAD ===
document.addEventListener('DOMContentLoaded', () => {
  initCartUpsellButtons();
  observeDrawerChanges();
});

// === OBSERVER: DETECTEER WIJZIGINGEN IN DE CARTDRAWER ===
function observeDrawerChanges() {
  const drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    initCartUpsellButtons();
  });

  observer.observe(drawer, { childList: true, subtree: true });
}

// === INTERVAL FALLBACK ===
let lastDrawerHTML = '';
setInterval(() => {
  const drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;

  const currentHTML = drawer.innerHTML;
  if (currentHTML !== lastDrawerHTML) {
    lastDrawerHTML = currentHTML;
    initCartUpsellButtons();
  }
}, 800);

// === PAGEFLY ERROR FAILSAFE ===
window.addEventListener('error', (event) => {
  if (event.message?.includes('forceUpdateCartStatus')) {
    console.warn('[Cart upsell] Cart update crash gedetecteerd - upsell wordt opnieuw geladen.');
    setTimeout(() => {
      initCartUpsellButtons();
    }, 500);
  }
});

// === AJAX FALLBACK (VOOR ANDERE APPS) ===
document.addEventListener('ajaxComplete', (e) => {
  if (e.detail?.url?.includes('/cart/add.js')) {
    setTimeout(() => {
      initCartUpsellButtons();
    }, 500);
  }
});

// === WINDOW LOAD FAILSAFE ===
window.addEventListener('load', () => {
  setTimeout(() => {
    initCartUpsellButtons();
  }, 1200);
});
